<template>
    <div>
        <div class="treetitle">
            <div class="tree-header-left">
                <img src="../assets/icon_level.svg" style="height:15px;vertical-align:middle"/><span v-t="'message.item_layerId'"></span>
                <img src="../assets/user.svg" style="padding-left:10px;height:15px;vertical-align:middle"/><span v-t="'message.item_userId_displayName'"></span>
                <img src="../assets/group.svg" style="padding-left:10px;height:18px;vertical-align:middle"/><span v-t="'message.item_groupId'"></span>
            </div>
            <div v-if="showSearchObject" class="tree-header-right">
                <button v-if="listType == 0" class="tree-command-button" type="button" v-on:click="listType=1"><img src="../assets/loupe.svg" style="height:18px;vertical-align:middle"/>
                    <div class="tree-command-text" v-t="'message.action_search_items'"></div>
                </button>
                <button v-if="listType == 1" class="tree-command-button" type="button" v-on:click="listType=0"><img src="../assets/icon_return.svg" style="height:18px;vertical-align:middle"/>
                    <div class="tree-command-text" v-t="'message.button_back'"></div>
                </button>
            </div>
        </div>
        <div v-if="listType == 1" class="treetitle" style="height: 56px">
            <el-form @submit.native.prevent="findObject()" style="padding-left: 20px;padding-top:5px">
                <el-input :placeholder="$t('message.place_holder_input_text')" v-model.trim="searchString" class="object-search-select" style="padding-left:0px;width:540px;" clearable @clear="searchString=null">
                    <el-select class="search-item" v-model="condition" slot="prepend" @change="handleChangeSearchCondition()">
                        <el-option style="font-size:12px" value="userId" :label="$t('message.item_userId')"></el-option>
                        <el-option style="font-size:12px" value="userName" :label="$t('message.item_userDisplayName')"></el-option>
                        <el-option style="font-size:12px" value="organization" :label="$t('message.item_organization')"></el-option>
                        <el-option style="font-size:12px" value="title" :label="$t('message.item_job_title')"></el-option>
                        <el-option style="font-size:12px" value="phone" :label="$t('message.item_tenant_phone')"></el-option>
                        <el-option style="font-size:12px" value="groupId" :label="$t('message.item_groupId')"></el-option>
                        <el-option style="font-size:12px" value="groupName" :label="$t('message.item_groupDisplayName')"></el-option>
                    </el-select>
                    <el-button slot="append" class="search-button" native-type="submit" v-t="'message.action_search_items'"></el-button>
                </el-input>
            </el-form>
        </div>
        <div v-if="listType == 0">
            <el-tree v-if="show && !noLazy"
                     class="common-object-tree"
                     :props="properties"
                     :load="loadNode"
                     node-key="id"
                     ref="tree"
                     lazy
                     highlight-current
                     default-expanded-keys="{1}"
                     :expand-on-click-node="false"
                     @node-click="handleNodeClick"
                     :render-content="renderContent">
            </el-tree>
            <el-tree v-else-if="show && noLazy"
                class="common-object-tree"
                :props="properties"
                :data="initialData"
                node-key="id"
                ref="tree"
                highlight-current
                default-expanded-keys="{1}"
                :expand-on-click-node="false"
                @node-click="handleNodeClick"
                :render-content="renderContent">
            </el-tree>
        </div>
        <div v-else style="height:calc(100vh - 232px);overflow-y:auto">
            <div class="foundObject-record" v-for="object in foundObjectList" @click="$emit('on-selectnode', object)">
                <div class="foundObject">
                    <img v-if="isAdminUser(object)" src="../assets/admin_user.svg" style="height:20px;vertical-align:middle"></img>
                    <img v-else-if="isFindUser() && isIpRadio(object)" src="../assets/IP_Radio/ip_radio_icon.png" style="height:20px;vertical-align:middle"></img>
                    <img v-else-if="isFindUser()" src="../assets/user.svg" style="height:20px;vertical-align:middle"></img>
                    <img v-else  src="../assets/group.svg" style="height:20px;vertical-align:middle"></img>
                    <span style="padding-left:10px;vertical-align:middle">{{ object.node.data.label }}</span>
                </div>
            </div>
        </div>
   </div>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';

export default {
    data() {
      return {
        show: true,
        loadingScreen: null,
        condition: "userId",
        searchString: null,
        listType: 0,
        foundObjectList: [],
        properties: {
            label: 'label',
            isLeaf: 'isLeaf',
        },
      };
    },
    props: {
        initialData: Object,
        talkgroupExpantion: {
            type: Boolean,
            default: false
        },
        showNodeObject: {
            type: Boolean,
            default: true
        },
        showUserObject: {
            type: Boolean,
            default: true
        },
        showTalkgroupObject: {
            type: Boolean,
            default: true
        },
        showAdminUser: {
            type: Boolean,
            default: true
        },
        showSearchObject: {
            type: Boolean,
            default: true
        },
        showAssistantObject: {
            type: Boolean,
            default: true
        },
        showBuddycomCallUserObject: {
            type: Boolean,
            default: true
        },
        showIpRadioObject: {
            type: Boolean,
            default: true
        },
        noLazy: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        handleNodeClick(data, node, elNode) {
            if(node.data.type == constants.OBJECT_TALKGROUP && this.talkgroupExpantion == true) {
                if (node.childNodes.length == 0) {
                    this.loadingScreen = this.$loading({
                            lock: true ,
                            text: 'Loading data ...' ,
                            spinner: 'el-icon-loading' ,
                            background: 'rgba(0, 0, 0, 0)'
                    });
                    let self = this;
                    let userDataList = [];
                    server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                    .then((res) => {
                        switch(res.data.status) {
                            case constants.STATUS_SUCCESS:
                                userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                                break;
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","handleNodeClick").replace("{code}",res.data.status));
                                break;
                        }
                        if (data.length == 0) {
                            node.loading = true;
                            node.isLeaf = true;
                            node.data.isLeaf = true;
                        } else {
                            for (let index = 0 ; index < userDataList.length ; index ++) {
                                if (index == 0) {
                                    self.$refs.tree.append(userDataList[index], node);
                                } else {
                                    self.$refs.tree.insertAfter(userDataList[index], node.childNodes[index -1]);
                                }
                            }
                        }
                        self.closeLoadingScreen();
                        self.$emit('on-selectnode', elNode)
                    })
                    .catch( function ( error ) {
                        self.closeLoadingScreen();
                        commonUtil.putExceptionErrorMessage(self, "handleNodeClick", error);
                    });
                } else {
                    this.$emit('on-selectnode', elNode)
                }
            } else {
                this.$emit('on-selectnode', elNode)
            }
        },
        handleChangeSearchCondition() {
            this.foundObjectList = [];
            return;
        },
        reload() {
            if (this.listType == 0) {
                this.show = false;
                this.$nextTick(() => {
                     this.show = true
                })
            } else {
                this.findObject();
            }
        },
        loadNode(node, resolve) {
            if (node.parent == null) {
                if (this.initialData.length > 0) {
                    resolve(this.initialData);
                }
                return;
            }
            let self = this;

            this.loadingScreen = this.$loading({
                    lock: true ,
                    text: 'Loading data ...' ,
                    spinner: 'el-icon-loading' ,
                    background: 'rgba(0, 0, 0, 0)'
            });

            if(node.data.type == constants.OBJECT_TALKGROUP && this.talkgroupExpantion == true){
              server.post('/gettalkerlist', {tenantId: node.data.tenantId, talkgroupId: node.data.id})
                .then((res) => {
                    if (res.data.status >= 0) {
                        let userDataList = [];
                        userDataList = self.getTalkerListNodeData(res.data.nodeInfo);
                        resolve(userDataList);
                    } else {
                        switch(res.data.status) {
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode-1").replace("{code}",res.data.status));
                                break;
                        }
                        node.loading = false;
                        node.isLeaf = true;
                        node.data.isLeaf = true;
                    }
                    self.closeLoadingScreen();
                })
                .catch( function ( error ) {
                    self.closeLoadingScreen();
                    commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                });

                return;
            }
            const payload = {tenantId: node.data.tenantId, parentId: node.data.id, type: -1};
            server.post('/getchildren', payload)
                .then((res) => {
                    if (res.data.status >= 0) {
                        let data = [];
                        if (self.showNodeObject && res.data.nodeInfo) {
                            for (let i = 0; i < res.data.nodeInfo.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.nodeInfo[i].id,
                                    label: res.data.nodeInfo[i].name,
                                    type: res.data.nodeInfo[i].type,
                                    isLeaf: res.data.nodeInfo[i].hasChild  == 0 ? true : false
                                });
                            }
                        }
                        if (self.showUserObject && res.data.userInfos) {
                            for (let i = 0; i < res.data.userInfos.length; i++) {
                                if (!self.showAdminUser &&
                                    res.data.userInfos[i].restrictions != null &&
                                    res.data.userInfos[i].restrictions.includes(constants.RESTRICTION_LOGIN))
                                {
                                    continue;
                                }

                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.userInfos[i].userId,
                                    name: res.data.userInfos[i].userName,
                                    label: res.data.userInfos[i].userName + " / " + res.data.userInfos[i].displayName,
                                    type: constants.OBJECT_USER,
                                    restrictions: res.data.userInfos[i].restrictions,
                                    isLeaf: true
                                });
                            }
                        }
                        if (self.showTalkgroupObject && res.data.talkGroupInfos) {
                            for (let i = 0; i < res.data.talkGroupInfos.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.talkGroupInfos[i].talkgroupId,
                                    label: res.data.talkGroupInfos[i].talkgroupName,
                                    type: constants.OBJECT_TALKGROUP,
                                    isLeaf: !this.talkgroupExpantion
                                });
                            }
                        }
                        if (self.showAssistantObject && res.data.assistantInfos) {
                            for (let i = 0; i < res.data.assistantInfos.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.assistantInfos[i].userId,
                                    name: res.data.assistantInfos[i].userName,
                                    label: res.data.assistantInfos[i].displayName,
                                    type: constants.OBJECT_ASSISTANT,
                                    isLeaf: true
                                });
                            }
                        }
                        if (self.showBuddycomCallUserObject && res.data.buddycomCallUserInfos) {
                            for (let i = 0; i < res.data.buddycomCallUserInfos.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: res.data.buddycomCallUserInfos[i].userId,
                                    name: res.data.buddycomCallUserInfos[i].userName,
                                    label: res.data.buddycomCallUserInfos[i].userName + " / " + res.data.buddycomCallUserInfos[i].displayName,
                                    type: constants.OBJECT_BUDDYCOM_CALL_USER,
                                    isLeaf: true
                                });
                            }
                        }
                        if (self.showIpRadioObject && res.data.ipRadioInfos) {
                            const ipRadioInfos = res.data.ipRadioInfos || [];
                            for (let i = 0; i < ipRadioInfos.length; i++) {
                                data.push({
                                    tenantId: node.data.tenantId,
                                    id: ipRadioInfos[i].userId,
                                    name: ipRadioInfos[i].userName,
                                    label: ipRadioInfos[i].userName + " / " + ipRadioInfos[i].displayName,
                                    type: constants.OBJECT_IP_RADIO,
                                    isLeaf: true
                                });
                            }
                        }

                        let typeOrder = commonUtil.getObjectTreeTypeOrder();
                        data.sort(function(e1, e2) {
                            let orderResult = typeOrder[e1.type] - typeOrder[e2.type]
                            if (orderResult !== 0) {
                                return orderResult;
                            }
                            else {
                                if(e1.type === constants.OBJECT_USER && e2.type === constants.OBJECT_USER){
                                    const e1LoginRestricted = (e1.restrictions != null && e1.restrictions.includes(constants.RESTRICTION_LOGIN)) ? 1 : 0;
                                    const e2LoginRestricted = (e2.restrictions != null && e2.restrictions.includes(constants.RESTRICTION_LOGIN)) ? 1 : 0;

                                    if (e1LoginRestricted !== e2LoginRestricted) {
                                        return e2LoginRestricted - e1LoginRestricted;
                                    }
                                }

                                let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                                if (comparisonResult < 0) return -1;
                                else if (comparisonResult > 0) return 1;
                            }
                            return 0;
                        });
                        resolve(data)
                    } else {
                        switch(res.data.status) {
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_expand_layer_denied") );
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","loadNode-2").replace("{code}",res.data.status));
                                break;
                        }
                        node.loading = false;
                        node.isLeaf = true;
                        node.data.isLeaf = true;
                    }
                    self.closeLoadingScreen();
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "loadNode", error);
                    self.closeLoadingScreen();
                });
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            switch (data.type) {
                case constants.OBJECT_NODE:
                    if (data.id == 1) {
                        objectIcon = require("../assets/icon_tenant.svg");
                    } else {
                        objectIcon = require("../assets/icon_level.svg");
                    }
                    break;
                case constants.OBJECT_USER:
                    if (data.restrictions != null &&
                        data.restrictions.includes(constants.RESTRICTION_LOGIN)
                    ) {
                        objectIcon = require("../assets/admin_user.svg");
                    } else {
                        objectIcon = require("../assets/user.svg");
                    }
                    break;
                case constants.OBJECT_TALKGROUP:
                    objectIcon = require("../assets/group.svg");
                    break;
                case constants.OBJECT_ASSISTANT:
                    objectIcon = require("../assets/assistant.svg");
                    break;
                case constants.OBJECT_CUSTOM_ASSISTANT:
                    objectIcon = require("../assets/assistant.svg");
                    break;
                case constants.OBJECT_BUDDYCOM_CALL_USER:
                    objectIcon = require("../assets/call_user.svg");
                    break;
                case constants.OBJECT_IP_RADIO:
                    objectIcon = require("../assets/IP_Radio/ip_radio_icon.png");
                    break
            }

            return h("span", [h("img", { attrs: { src: objectIcon ,height: "20px", style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        async addGroup(selectedNode, input) {
            let res;
            try {
                res = await server.post(
                    '/createnode',
                    {
                        operation:
                            {
                                parentId: selectedNode.node.data.id,
                                name: input.name,
                                acl: input.acl,
                                clientSettingId: input.clientSettingId
                            }
                    }
                );
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "addGroup", error);
                if (typeof input.onComplete === 'function') {
                    input.onComplete(-1);
                }
                return [false, -1];
            }

            if (res.data.status !== constants.STATUS_SUCCESS) {
                switch (res.data.status) {
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_create_node_denied"));
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_cannot_create_layer_duplicate") );
                        break;
                    default:
                        commonUtil.notifyMessage(this,"Error",commonUtil.getMessageText(this.$i18n,"error_server_api").replace("{functionName}","addGroup").replace("{code}",res.data.status));
                        break;
                }
                if (typeof input.onComplete === 'function') {
                    input.onComplete(-1);
                }
                return [false, -1];

            }

            commonUtil.notifyMessage(this,"Success",commonUtil.getMessageText(this.$i18n,"info_created_layer"));

            var insertData =
                {
                    data : {
                        tenantId: selectedNode.node.data.tenantId,
                        id: res.data.createdId,
                        label: input.name,
                        type: 0,
                        isLeaf: true
                    }
                };
            var insertIndex = this.getInsertIndexOfNode(selectedNode.node , input.name);

            if (insertIndex < 0) {
                selectedNode.node.insertBefore(insertData,selectedNode.node.childNodes[0]);
            } else {
                selectedNode.node.insertAfter(insertData,selectedNode.node.childNodes[insertIndex]);
            }

            if ((!selectedNode.node.isLeaf) && (!selectedNode.node.loaded)) {
                selectedNode.node.expand(() => {
                    selectedNode.node.loaded = true;
                });
            } else {
                selectedNode.node.expand();
            }
            if (typeof input.onComplete === 'function') {
                input.onComplete(res.data.createdId);
            }

            return [true, res.data.createdId];
        },
        addTalkgroup: function(selectedNode, input) {
            let self = this;
            server.post(
                '/createtalkgroup',
                {
                    operation:
                    {
                        parentId: selectedNode.node.data.id,
                        name: input.name,
                        displayName: input.displayName,
                        region: input.region,
                        talkgroupOptions: input.talkgroupOptions,
                        durationLimit: input.durationLimit,
                        videoDurationLimit: input.videoDurationLimit,
                        processorDefinitionIds: input.processorDefinitionIds,
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_created_group"));
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_create_group_denied"));
                            break;
                        case constants.STATUS_ERROR_TOO_MANY_ENTRY:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_create_group_exceeds_max"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_create_group_duplicate"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addTalkgroup").replace("{code}",res.data.status));
                            break;
                    }
                    if (typeof input.onComplete === 'function') {
                        input.onComplete(-1);
                    }
                    return;
                }

                var insertData = { data :
                                    {
                                        tenantId: selectedNode.tenantId,
                                        id: res.data.createdId,
                                        label: input.name,
                                        type: 2,
                                        isLeaf: true
                                     }
                                 };
                var insertIndex = this.getInsertIndexOfTalkgroup(selectedNode.node ,input.name);

                if (insertIndex < 0) {
                    selectedNode.node.insertBefore(insertData,selectedNode.node.childNodes[0]);
                } else {
                    selectedNode.node.insertAfter(insertData,selectedNode.node.childNodes[insertIndex]);
                }

                if ((!selectedNode.node.isLeaf) && (!selectedNode.node.loaded)) {
                    selectedNode.node.expand(() => {
                        selectedNode.node.loaded = true;
                    });
                } else {
                    selectedNode.node.expand();
                }
                if (typeof input.onComplete === 'function') {
                    input.onComplete(res.data.createdId);
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addTalkgroup", error);
                if (typeof input.onComplete === 'function') {
                    input.onComplete(-1);
                }
            });
        },
        addUser: function(selectedNode, input) {
            let self = this;
            server.post(
                '/createuser',
                {
                    operation:
                    {
                        parentId: selectedNode.node.data.id,
                        name: input.name,
                        displayName: input.displayName,
                        password: input.password,
                        organization: input.organization,
                        title: input.title,
                        phoneNumber: input.phoneNumber,
                        emailAddress: input.emailAddress,
                        userOptions: input.userOptions,
                    }
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_created_user"));
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_create_user_denied"));
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_create_user_duplicate"));
                            break;
                        case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_create_user_insufficient_license"));
                            break;
                        case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_create_user_insufficient_option"));
                            break;
                        case constants.STATUS_ERROR_CLOSING_RUNNING:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_cannot_create_user_no_contract"));
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addUser").replace("{code}",res.data.status));
                    }
                    if (typeof input.onComplete === 'function') {
                        input.onComplete(-1);
                    }
                    return;
                }

                var insertData = { data :
                                    {
                                        tenantId: selectedNode.tenantId,
                                        id: res.data.createdId,
                                        label: input.name + " / " + input.displayName,
                                        type: 1,
                                        isLeaf: true
                                     }
                                 };
                var insertIndex = this.getInsertIndexOfUser(selectedNode.node , input.name);
                if (insertIndex < 0) {
                    selectedNode.node.insertBefore(insertData,selectedNode.node.childNodes[0]);
                } else {
                    selectedNode.node.insertAfter(insertData,selectedNode.node.childNodes[insertIndex]);
                }

                if ((!selectedNode.node.isLeaf) && (!selectedNode.node.loaded)) {
                    selectedNode.node.expand(() => {
                        selectedNode.node.loaded = true;
                    });
                } else {
                    selectedNode.node.expand();
                }
                if (typeof input.onComplete === 'function') {
                    input.onComplete(res.data.createdId);
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addUser", error);
                if (typeof input.onComplete === 'function') {
                    input.onComplete(-1);
                }
            });
        },
        addBuddycomCallUser: function (selectedNode, input) {
            let self = this

            // 子Vueから受けとったパラメーター
            server.post(
                '/createbuddycomcalluser', {
                    parentId:               selectedNode.node.data.id,
                    name:                   input.name,
                    displayName:            input.displayName,
                    password:               input.password,
                    talkGroupId:            input.targetGroup.talkgroupId,
                    requestTimeOut:         input.requestTimeOut,
                    idlingVoiceEnabled:     input.idlingVoiceEnabled,
                    idlingText:             input.idlingText
                }
            ).then((res) => {
                if (res.data.status == constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "info_created_user"))
                } else {
                    switch (res.data.status) {
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_create_user_denied"))
                            break;
                        case constants.STATUS_ERROR_ALREADY_EXISTED:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_duplicate"))
                            break;
                        case constants.STATUS_ERROR_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_insufficient_license"))
                            break;
                        case constants.STATUS_ERROR_OPTION_LICENSE_INSUFFICIENT:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_insufficient_option"))
                            break;
                        case constants.STATUS_ERROR_CLOSING_RUNNING:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_cannot_create_user_no_contract"))
                            break;
                        case constants.STATUS_ERROR_NO_MORE_FREE_SLOT:
                            commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_buddycom_call_no_more_free_slot"));
                            break;
                        default:
                            commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "addBuddycomCallUser").replace("{code}", res.data.status))
                    }
                    return
                }

                var insertData = {
                    data: {
                        tenantId: selectedNode.tenantId,
                        id: res.data.createdId,
                        label: input.name + " / " + input.displayName,
                        type: constants.OBJECT_BUDDYCOM_CALL_USER,
                        isLeaf: true
                    }
                }

                var insertIndex = this.getInsertIndexOfBuddycomCallUser(selectedNode.node, input.name)
                if (insertIndex < 0) {
                    selectedNode.node.insertBefore(insertData, selectedNode.node.childNodes[0])
                } else {
                    selectedNode.node.insertAfter(insertData, selectedNode.node.childNodes[insertIndex])
                }

                if ((!selectedNode.node.isLeaf) && (!selectedNode.node.loaded)) {
                    selectedNode.node.expand(() => {
                        selectedNode.node.loaded = true
                    })
                } else {
                    selectedNode.node.expand()
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(self, "addBuddycomCallUser", error);
            })
        },
        getInsertIndexOfNode: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            return insertIndex;
        },
        getInsertIndexOfUser: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let nodeLastIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    nodeLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 1) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            if (insertIndex == -1) {
                if (nodeLastIndex >= 0) {
                    insertIndex = nodeLastIndex;
                }
            }
            return insertIndex;
        },
        getInsertIndexOfTalkgroup: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let nodeLastIndex = -1;
            let userLastIndex = -1;
            for (let i = 0 ; i < parentNode.childNodes.length ; i++) {
                if (parentNode.childNodes[i].data.type == 0) {
                    nodeLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 1) {
                    userLastIndex = i;
                } else if (parentNode.childNodes[i].data.type == 2) {
                    if (commonUtil.compareStringWithNumber(parentNode.childNodes[i].data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    } else {
                        break;
                    }
                }
            }
            if (insertIndex == -1) {
                if (userLastIndex >= 0) {
                    insertIndex = userLastIndex;
                } else if (nodeLastIndex >= 0) {
                    insertIndex = nodeLastIndex;
                }
            }
            return insertIndex;
        },
        getInsertIndexOfBuddycomCallUser: function(parentNode , insertObjectName) {
            let insertIndex = -1;
            let lastIndex = -1;
            for (let i = 0; i < parentNode.childNodes.length; i++) {
                const node = parentNode.childNodes[i];
                const type = node.data.type;

                if (type === constants.OBJECT_BUDDYCOM_CALL_USER) {
                    if (commonUtil.compareStringWithNumber(node.data.label, insertObjectName) < 0) {
                        insertIndex = i;
                    }
                } else {
                    lastIndex = i;
                }
            }

            return Math.max(insertIndex, lastIndex);
        },
        resetCurrentNode(forceReset) {
            if ((typeof this.$refs.tree.currentNodeKey != "undefined") || (forceReset)) {
                this.$refs.tree.setCurrentKey(null);
            }
        },
        closeLoadingScreen() {
            if (this.loadingScreen != null) {
                this.loadingScreen.close();
                this.loadingScreen = null;
            }
        },
        getTalkerListNodeData(nodeData) {
            let data = [];
            for (let i = 0; i < nodeData.length; i++) {
                data.push({
                    tenantId: nodeData[i].tenantId,
                    id: nodeData[i].id,
                    label: nodeData[i].name + " / " + nodeData[i].displayName,
                    type: constants.OBJECT_USER,
                    markerIcon: nodeData[i].markerIcon,
                    displayName: nodeData[i].displayName,
                    type: constants.OBJECT_USER,
                    isLeaf: true
                })
            }
            data.sort(function(e1, e2) {
                if (e1.type < e2.type) return -1;
                else if (e1.type > e2.type) return 1;
                else {
                    let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                    if (comparisonResult < 0) return -1;
                    else if (comparisonResult > 0) return 1;
                }
                return 0;
            });
            return data;
        },
        findObject() {
            let param = {tenantId: this.initialData[0].tenantId}
            let postUrl;
            switch(this.condition) {
                case "userId":
                case "userName":
                case "organization":
                case "title":
                case "phone":
                    if (this.condition == "userId") {
                        param.name = this.searchString;
                    } else if (this.condition == "userName") {
                        param.displayName = this.searchString;
                    } else if (this.condition == "organization") {
                        if (this.searchString != "") {
                            param.organization = this.searchString;
                        }
                    } else if (this.condition == "title") {
                        if (this.searchString != "") {
                            param.title = this.searchString;
                        }
                    } else if (this.condition == "phone") {
                        if (this.searchString != "") {
                            param.phone = this.searchString;
                        }
                    }
                    param.includingIpRadio = true;
                    postUrl = "/finduser";
                    break;
                case "groupId":
                case "groupName":
                    if (this.condition == "groupId") {
                        param.name = this.searchString;
                    } else if (this.condition == "groupName") {
                        param.displayName = this.searchString;
                    }
                    postUrl = "/findgroup";
                    break;
            }
            let self = this;
            server.post(postUrl, param)
            .then((res) => {
                let resultData;
                let resultDataType;
                if (res.data.status == constants.STATUS_SUCCESS) {
                    if (postUrl == "/finduser") {
                        resultData = res.data.userInfo;
                        resultDataType = constants.OBJECT_USER;
                    } else {
                        resultData = res.data.groupInfo;
                        resultDataType = constants.OBJECT_TALKGROUP;
                    }
                    if (resultData.length == 0) {
                        self.foundObjectList = [];
                        if (resultDataType == constants.OBJECT_USER) {
                            commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_user_not_found"));
                        } else {
                            commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_group_not_found"));
                        }
                        return;
                    }
                } else {
                    self.foundObjectList = [];
                    commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","findObject").replace("{code}",res.data.status));
                    return;
                }
                self.foundObjectList = [];
                for (let objectInfo of resultData) {
                    let object = { node : { data: null, parent: { data: null} } }
                    let label;
                    let dataType;
                    if (resultDataType == constants.OBJECT_USER) {
                        label = objectInfo.name + " / " + objectInfo.displayName
                        dataType = objectInfo.type;
                    } else {
                        label = objectInfo.name
                        dataType = resultDataType;
                    }
                    object.node.data = {
                        tenantId: self.initialData[0].tenantId,
                        type: dataType,
                        id: objectInfo.id,
                        name: objectInfo.name ,
                        displayName: objectInfo.displayName,
                        restrictions : objectInfo.restrictions,
                        label: label
                    };
                    object.node.parent.data = {id: objectInfo.pid}
                    self.foundObjectList.push(object);
                }
                self.foundObjectList.sort(function(o1, o2) {
                    let e1 = o1.node.data;
                    let e2 = o2.node.data;
                    if (e1.type < e2.type) return -1;
                    else if (e1.type > e2.type) return 1;
                    else {
                        let comparisonResult = commonUtil.compareStringWithNumber(e1.label, e2.label);
                        if (comparisonResult < 0) return -1;
                        else if (comparisonResult > 0) return 1;
                    }
                    return 0;
                });
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "findObject", error);
                self.foundObjectList = [];
            });
        },
        isAdminUser(object){
            return object.node.data.restrictions != null && object.node.data.restrictions.includes(constants.RESTRICTION_LOGIN);
        },
        isFindUser() {
            switch(this.condition) {
                case "userId":
                case "userName":
                case "organization":
                case "title":
                case "phone":
                    return true;
                case "groupId":
                case "groupName":
                    return false;
            }
        },
        isIpRadio(object){
            return object.node.data.type == constants.OBJECT_IP_RADIO;
        },
        getNodeById(id) {
            return this.$refs.tree.getNode(id);
        }
    },
    updated: function () {
    },
    watch: {
        listType(value) {
            if (value == 1) {
                this.$emit('changeListType', this.listType)
                if (this.listType == 1) {
                    this.foundObjectList = [];
                    this.searchString = null;
                    this.condition = "userId";
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background-color: #ecf1fa !important;
}

.el-tree-node > .el-tree-node__content:hover {
    background-color: #ecf1fa !important;
}
.el-tree-node__content {
    height: 40px !important;
}
.el-tree-node__content img {
    margin-left: -20px !important;
    padding-right: 8px !important;
}
.el-tree-node__expand-icon {
    padding: 28px !important;
}

</style>

<style scoped>

.tree-command-text {
    padding-left: 5px;
    display: inline-block;
    font-size: 12px;
    color: #5171cb;
    vertical-align: middle;
}
.tree-command-text:hover {
    opacity: 0.7;
}

button.tree-command-button {
    border-style: none;
    color: #333B48;
    background-color: transparent;
    cursor: pointer;
    outline: 0;
    padding-top: 10px;
}

.tree-header-left {
    vertical-align: middle;
    padding-top: 12px;
    padding-left: 20px;
    float: left;
}
.tree-header-right {
    text-align : right;
    vertical-align: middle;
    padding-top: 2px;
    padding-bottom: 3px;
    padding-right: 20px;
}

.treetitle {
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
    white-space: nowrap;
    height: 42px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
.panel {
    background: #fff;
    padding: 20px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -150px;
    margin-top: -100px;
    transition: all .3s ease;
    min-width: 630px;
}
.modal-default-button {
  float: right;
}

.el-select-dropdown__item {
    font-size: 12px;
}
.el-select-dropdown__item selected {
    color: #5171cb;
}

.common-object-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.common-object-tree.el-tree {
    overflow-x: hidden;
    overflow-y: auto;
}
.common-object-tree.el-tree {
    width: 100%;
    height: calc(100vh - 175px);
}
</style>
